import { Post } from "domain/infra/data/api";
import AuthConstants from "../../infra/data/authConstants";
import { ConfirmarSenhaRequest } from "../../types/confirmarSenha/confirmarSenhaRequest";
import ValidationResult from "domain/types/global/validationResult";

export class ConfirmarSenhaService {
  constructor() {}

  async ValidarTokenSenha(request : {Token: string}): Promise<ValidationResult | Error> {
    return await Post(
      AuthConstants.apiAuth.auth.validarTokenSenha, 
      request
    );
  }

  async ConfirmarSenha(payload: ConfirmarSenhaRequest, dispatchName: string): Promise<ValidationResult | Error> {
    return await Post(
      AuthConstants.apiAuth.auth.confirmarSenha, 
      payload, 
      dispatchName
    );
  }


}
